import React from "react";

export default class Question extends React.Component {
  render() {
    return (
      <div className="question">
        Factors millennials expect will influence their financial security, around the world.
        <style jsx>{`
          .question {
            color: #444;
            font-family: FrutigerLTCom;
            font-weight: 300;
            font-size: 24px;
            line-height: 32px;
            text-align: center;
            margin: 0 0 16px 0;
            width: 100%;
          }
          @media screen and (max-width : 768px) {
              .question {
                   font-size: 16px;
                   line-height: 24px;
                   text-align: left;
              }
          }
        `}</style>
        </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Charts/Question.js